import { useState } from "react";
import { useEffect } from "react";
import { ApiCreditos } from "../../Helpers/ApiCreditos";
import Resumen from "./Modals/Resumen";
import Panel from "./Panel/panel";
import Tabla_creditos from "./Tablas/Tabla_creditos";
import Swal from "sweetalert2";
import { AuthContext, clienteAxios } from "../shared";
import Caja from "./Modals/Caja";
import { ApiPagos } from "../../Helpers/ApiPagos";
import { ApiPersonas } from "../../Helpers/ApiPersonas";
import { CuotaPago } from "../../functions/Validaciones/CuotaPago";
import { CreditoDetalles } from "../../functions/Validaciones/CreditoDetalles";
import {
  CorregirBug,
  PagarCuota,
  corregir_bug,
} from "../../functions/FunctionCuota";
import { CuotasDetalle } from "../../functions/Validaciones/CuotasDetalle";
import Comprobante from "./Modals/Comprobante";
import { useContext } from "react";
import { format } from "date-fns";
import AlertSuccess from "../CustomAlerts/AlertSuccess";
import Tabla_judiciales from "./Tablas/Tabla_judiciales";
import { ApiJudiciales } from "../../Helpers/ApiJudiciales";
import Gasto from "./Modals/Gasto";
import Juicio from "./Modals/Juicio";
import ResumenJudicial from "./Modals/ResumenJudicial";
import PanelJudicial from "./Panel/panelJudicial";
import { CalculoPagoJudicial } from "../../functions/Validaciones/PagoJudicial";
import AlertWarning from "../CustomAlerts/AlertWarning";
import Modal from "../../module/modal/Modal";
import ComprobanteGastoController from "./Modals/CompobanteGasto";
import "../shared/styles/ViewContainer.css";

const GestionPagos = () => {
  const authContext = useContext(AuthContext);
  const { usuario, cerrarSesion } = authContext;

  const autocomplete = {
    top: "40px",
    zIndex: "2",
  };
  //modals
  const [comprobante, setComprobante] = useState(false);
  const [comprobanteGasto, setComprobanteGasto] = useState(false);
  const [PagoJudicial, setPagoJudicial] = useState(false);
  const [caja, setCaja] = useState(false);
  const [resumen, setResumen] = useState(false);
  const [gasto, setGasto] = useState(false);
  const [resumenJudicial, setResumenJudicial] = useState(false);
  const [showCreditos, setShowCreditos] = useState(true);
  const [showGastosJudiciales, setShowGastosJudiciales] = useState(true);
  //
  const [panelJuicio, setPanelJuicio] = useState(false);
  const [pago, setPago] = useState(false);
  const [steps, setSteps] = useState(0);
  const [loading, setLoading] = useState(false);
  const [judiciales, setJudiciales] = useState(null);
  const [juicio, setJuicio] = useState(null);

  //formularios
  const [form, setForm] = useState({
    //PAGO
    importe_cuota: "",
    importe: "",
    estado: "",
    prev_estado: "",
    forma_pago: "",
    fecha_importe: "",
    comentarios: "",
    //CREDITO
    credito_id: "",
    credito_detalle_id: "",
    id_concesion: "",
    monto_concesion: "",
    interes_punitorios: "",
    //Cuota siguiente
    sig_cuotas: "",
  });

  //params
  const [params_pago, setParamsPago] = useState({
    id: "",
    buscar: "",
  });
  const [params_persona, setParamsPersona] = useState({
    buscar: "",
    page: 1,
    paginator: 30,
  });
  const [params_credito, setParamsCredito] = useState({
    persona: null,
    estados: "",
  });
  const [params_judicial, setParamsJudicial] = useState({
    persona: null,
  });
  const [selectStatus, setSelectStatus] = useState('Todos');

  //state
  const [dataPagos, setPagos] = useState([]);
  const [dataPersonas, setPersonas] = useState([]);
  const [dataCreditos, setCreditos] = useState([]);
  const [credito, setCredito] = useState(null);
  const [cuota, setCuota] = useState(null);

  //events
  const onClick = (e, value) => {
    switch (e.target.name) {
      case "delete-gasto":
        {
          if (value.pagos.length > 0) {
            return AlertWarning({
              message:
                "El gasto contiene pagos habilitados, no se puede eliminar",
              title: "Danger",
            });
          }
          //LLave de administrador
          Swal.fire({
            title: "Cancelar pago",
            html:
              "<p>¿Quieres dar de baja el siguiente gasto?</p>" +
              '<ul class="list-group"><li class="list-group-item border-0 d-flex justify-content-between"><div>Estado</div><div>' +
              value.item +
              '</div></li><li class="list-group-item border-0 d-flex justify-content-between"><div>Fecha de importe</div><div>' +
              value.fecha_otorgamiento +
              '</div></li><li class="list-group-item border-0 d-flex justify-content-between"><div>Tipo de importe</div><div>' +
              value.monto +
              '</ul><div class="my-3 text-muted"> Para confirmar la baja de un pago se necesitan credenciales de administrador, ingrese su clave para completar la baja.</div>',
            input: "password",
            inputAttributes: {
              autocapitalize: "off",
            },
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Eliminar",
            showLoaderOnConfirm: true,
            preConfirm: async (result) => {
              let formData = new FormData();
              formData.append("id", value.id);
              formData.append("password", result);

              const response = await clienteAxios({
                method: "post",
                url: "/PersonaJudicial/delete",
                data: formData,
              })
                .then((result) => {
                  Swal.fire({
                    title: `Se dio de Baja Correctamente`,
                  });

                  //Actualizar datos
                  setSteps(steps + 1);
                })
                .catch((result) => {
                  return Swal.showValidationMessage(
                    `Request failed: ${result.response.data.messages.msg}`
                  );
                });
            },
            allowOutsideClick: () => !Swal.isLoading(),
          }).then((result) => {
            console.log("ok");
          });
        }
        break;
      case "resumen-judicial":
        {
          setJuicio({
            ...value,
            exmonto: CalculoPagoJudicial(value).exmonto,
            deuda: CalculoPagoJudicial(value).deuda,
            interes: CalculoPagoJudicial(value).interes,
          });
          setResumenJudicial(true);
        }
        break;
      case "crear-gasto":
        {
          setGasto(true);
        }
        break;
      //C-bug
      case "reacomodar-pagos":
        {
          corregir_bug(value);

          AlertSuccess({ message: "Correccion de bug completada..." });
          setResumen(false);
          //return window.location.reload(true)
        }
        break;
      //actions
      case "delete_payment":
        {
          //LLave de administrador
          Swal.fire({
            title: "Cancelar pago",
            html:
              "<p>¿Quieres dar de baja el siguiente pago?</p>" +
              '<ul class="list-group"><li class="list-group-item border-0 d-flex justify-content-between"><div>Estado</div><div>' +
              value.estado +
              '</div></li><li class="list-group-item border-0 d-flex justify-content-between"><div>Fecha de importe</div><div>' +
              value.fecha_importe +
              '</div></li><li class="list-group-item border-0 d-flex justify-content-between"><div>Tipo de importe</div><div>' +
              value.forma_pago +
              '</div></li><li class="list-group-item border-0 d-flex justify-content-between"><div>Importe</div><div>' +
              value.importe +
              '</div></li></ul><div class="my-3 text-muted"> Para confirmar la baja de un pago se necesitan credenciales de administrador, ingrese su clave para completar la baja.</div>',
            input: "password",
            inputAttributes: {
              autocapitalize: "off",
            },
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Eliminar",
            showLoaderOnConfirm: true,
            preConfirm: async (result) => {
              let formData = new FormData();
              formData.append("id", value.id);
              formData.append("password", result);

              const response = await clienteAxios({
                method: "post",
                url: "/Pago/darBaja",
                data: formData,
              })
                .then((result) => {
                  Swal.fire({
                    title: `Se dio de Baja Correctamente`,
                  });

                  //Actualizar datos
                  setResumen(false);
                  setSteps(steps + 1);
                })
                .catch((result) => {
                  return Swal.showValidationMessage(
                    `Request failed: ${result.response.data.messages.msg}`
                  );
                });
            },
            allowOutsideClick: () => !Swal.isLoading(),
          }).then((result) => {
            console.log("ok");
          });
        }
        break;
      case "pagar-juidicial":
        {
          if (CalculoPagoJudicial(value).deuda < 1) {
            return "";
          }
          setPanelJuicio(true);
          setJuicio({
            ...value,
            exmonto: CalculoPagoJudicial(value).exmonto,
            deuda: CalculoPagoJudicial(value).deuda,
            interes: CalculoPagoJudicial(value).interes,
          });
          setCuota(null);
          setCredito(null);
        }
        break;
      case "persona":
        {
          setParamsCredito({
            ...params_credito,
            [e.target.name]: value,
          });

          //reset
          setParamsPersona({
            ...params_persona,
            buscar: "",
          });

          setParamsJudicial({
            ...params_judicial,
            persona: value,
          });

          setJudiciales(null);
          setCuota(null);
          setCredito(null);
        }
        break;
      case "filtro-credito":
        {
          let estado = e.target.value;

          if (e.target.value == 'Activos') {
            estado = ['Vigente', 'No Vigente', 'Cancelado', 'Pagado']
            setSelectStatus(e.target.value);

            setParamsCredito({
              ...params_credito,
              estados: estado,
            });
            setCuota(null);
            setCredito(null);
            return
          }

          if (e.target.value == 'Todos') {
            estado = "";
            setSelectStatus(e.target.value);

            setParamsCredito({
              ...params_credito,
              estados: estado,
            });
            setCuota(null);
            setCredito(null);
            return
          }


          setSelectStatus(e.target.value);
          setParamsCredito({
            ...params_credito,
            estados: estado,
          });
          setCuota(null);
          setCredito(null);
          return

        }
        break;
      case "credito":
        {
          let credito = () => CreditoDetalles(value);
          let cuota = () => PagarCuota(CreditoDetalles(value).detalles);
          setCuota(cuota);
          setCredito(credito);
          setJuicio(null);

          //reseteo de datos
          setForm({
            //PAGO
            importe: "",
            estado: "",
            forma_pago: "",
            fecha_importe: "",
            comentarios: "",
            //CREDITO
            credito_id: "",
            credito_detalle_id: "",
            id_concesion: "",
            monto_concesion: "",
            interes_punitorios: "",
            //
          });
        }
        break;
      //modals
      case "caja":
        {
          setCaja(value);
        }
        break;
      case "resumen":
        {
          let cuota = () => PagarCuota(value.detalles);
          let credito = () => CreditoDetalles(value);
          setCuota(cuota);
          setCredito(credito);
          setResumen(true);

          /*scroll div*/
          return (window.location.href = "#modal-resumen");
        }
        break;
      case "close":
        {
          setResumenJudicial(null);
          setResumen(false);
          setCaja(false);
          setComprobante(false);
          setPago(null);
          setJuicio(null);
          setComprobanteGasto(false)
        }
        break;
    }
  };

  const onChange = (e) => {
    switch (e.target.name) {
      case "buscar":
        {
          if (e.target.value.length > 3) {
            setParamsPersona({
              ...params_persona,
              [e.target.name]: e.target.value,
              page: 1,
              paginator: 30,
            });
          } else {
            if (e.target.value.length == "") {
              setParamsPersona({
                ...params_persona,
                [e.target.name]: "",
                page: 1,
                paginator: 30,
              });
            }
          }
        }
        break;
    }
  };
  //personas
  useEffect(() => {
    const load = async () => {
      const response = await clienteAxios.get("/Persona/getAll", {
        params: { texto: params_persona.buscar, page: 1, paginator: 30 },
      });

      setPersonas(response.data.personas.personas);
    };
    load();
  }, [params_persona, steps]);
  //creditos
  useEffect(() => {
    const load = async () => {
      if (params_credito.persona) {
        const response = await ApiCreditos({
          url: "/PersonaCreditos/getAllByIdPersona",
          params: params_credito,
          setLoading: setLoading,
        });

        setCreditos(response);
      }
    };
    load();
  }, [params_credito, steps]);
  //Pagos
  useEffect(() => {
    const load = async () => {
      const response = await ApiPagos({
        url: "/Pago/getAll",
        params: params_pago,
        setLoading: setLoading,
      });

      setPagos(response);
    };
    load();
  }, [params_pago, steps]);
  //judiciales
  useEffect(() => {
    const load = async () => {
      if (params_judicial.persona) {
        const response = await ApiJudiciales({
          url: "/PersonaJudicial/index",
          params: params_judicial,
          setLoading: setLoading,
        });

        setJudiciales(response);
      }
    };
    if (true) {
      load();
    }
  }, [params_judicial, steps]);

  //Logs
  //console.log(params_credito.persona);
  return (
    <div style={{
      background: '#F8FAFC',
      minHeight: '100vh',
      padding: '24px'
    }}>
      <div style={{ maxWidth: "1600px", margin: '0 auto' }}>
        {/* Header */}
        <div className="mb-4">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div>
              <h1 className="view-title mb-1">Gestión de Pagos</h1>
              <p className="text-muted mb-0">Administra créditos, gastos judiciales y pagos de clientes</p>
            </div>

            <div className="search-input-container" style={{ maxWidth: "500px", minWidth: "300px" }}>
            <input
              type="text"
              className="search-input"
              placeholder="Buscar cliente por nombre o DNI..."
              autoComplete="off"
              name="buscar"
              onChange={(event) => onChange(event)}
            />
            <i className="bi bi-search search-icon"></i>

            {params_persona.buscar.trim() !== "" && (
              <ul className="list-group position-absolute w-100 shadow-lg" style={{
                top: '60px',
                zIndex: 1000,
                maxHeight: '400px',
                overflowY: 'auto',
                borderRadius: '12px'
              }}>
                {dataPersonas.map((persona, index) => (
                  <li key={index} className="list-group-item border-0 p-0">
                    <button
                      className="btn btn-light w-100 text-start p-3 d-flex justify-content-between align-items-center"
                      style={{
                        borderBottom: index < dataPersonas.length - 1 ? '1px solid #E2E8F0' : 'none',
                        borderRadius: index === 0 ? '12px 12px 0 0' : index === dataPersonas.length - 1 ? '0 0 12px 12px' : '0'
                      }}
                      name="persona"
                      onClick={(event) => onClick(event, persona)}
                    >
                      <div>
                        <div className="fw-semibold" style={{ color: '#1E293B' }}>
                          {persona.apellido}, {persona.nombre}
                        </div>
                        <small className="text-muted">DNI: {persona.nro_documento}</small>
                      </div>
                      <i className="bi bi-chevron-right text-muted"></i>
                    </button>
                  </li>
                ))}
              </ul>
            )}
            </div>
          </div>
        </div>

        {/* Cliente Seleccionado */}
        {params_credito.persona && (
        <div className="mb-4 fade-in">
          <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', background: 'linear-gradient(135deg, #155E75 0%, #0F3D4A 100%)' }}>
            <div className="card-body p-4">
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                <div className="d-flex align-items-center gap-3">
                  {/* Avatar */}
                  <div
                    className="d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{
                      width: "64px",
                      height: "64px",
                      borderRadius: "50%",
                      background: "rgba(255, 255, 255, 0.25)",
                      color: "white",
                      fontWeight: "700",
                      fontSize: "1.5rem",
                      border: "3px solid rgba(255, 255, 255, 0.3)"
                    }}
                  >
                    {`${params_credito.persona.apellido?.[0] || ""}${params_credito.persona.nombre?.[0] || ""}`.toUpperCase()}
                  </div>

                  {/* Información */}
                  <div>
                    <div className="fw-bold fs-4 text-white mb-1">
                      {params_credito.persona.apellido}, {params_credito.persona.nombre}
                    </div>
                    <div className="d-flex gap-3 align-items-center">
                      <small className="text-white opacity-75">
                        <i className="bi bi-person-badge me-1"></i>
                        DNI: {params_credito.persona.nro_documento}
                      </small>
                      <small className="text-white opacity-75">
                        <i className="bi bi-hash me-1"></i>
                        ID: {params_credito.persona.id}
                      </small>
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-2 align-items-center">
                  {params_credito.persona.estado && (
                    <span
                      className={`badge fs-6 px-3 py-2 ${
                        params_credito.persona.estado === "Aceptada"
                          ? "bg-success"
                          : params_credito.persona.estado === "Pendiente"
                          ? "bg-warning text-dark"
                          : params_credito.persona.estado === "Rechazada"
                          ? "bg-danger"
                          : params_credito.persona.estado === "Observada"
                          ? "bg-info text-dark"
                          : params_credito.persona.estado === "Juicio" || params_credito.persona.estado === "Juicio - Ejecución"
                          ? "bg-danger"
                          : "bg-secondary"
                      }`}
                    >
                      {params_credito.persona.estado}
                    </span>
                  )}

                  <a
                    href={`/clientes/ver/${params_credito.persona.id}`}
                    className="btn btn-light px-4"
                    style={{ borderRadius: '8px', fontWeight: '600' }}
                  >
                    <i className="bi bi-person-vcard me-2"></i>
                    Ver Ficha
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        )}

        {/* Sección Créditos */}
        <div className="mb-4">
        <div className="bg-white rounded-4 shadow-sm overflow-hidden">
          <div className="p-4 d-flex justify-content-between align-items-center" style={{
            background: 'linear-gradient(90deg, #F8FAFC 0%, #E2E8F0 100%)',
            borderBottom: showCreditos ? '2px solid #E2E8F0' : 'none'
          }}>
            <div className="d-flex align-items-center gap-3">
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '12px',
                background: 'linear-gradient(135deg, #155E75 0%, #0F3D4A 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '20px'
              }}>
                <i className="bi bi-credit-card-2-front"></i>
              </div>
              <div>
                <h3 className="mb-0 fw-bold" style={{ color: '#1E293B' }}>Créditos</h3>
                <small className="text-muted">Gestión de créditos del cliente</small>
              </div>
            </div>

            <div className="d-flex gap-2 align-items-center">
              {params_credito.persona && (
                <select
                  className="form-select form-select-sm"
                  style={{ width: "auto", minWidth: "140px", borderRadius: '8px' }}
                  name="filtro-credito"
                  value={selectStatus}
                  onChange={(e) => onClick(e, e.target.value)}
                >
                  <option value="Todos">Todos</option>
                  <option value="Activos">Activos</option>
                  <option value="Eliminado">Eliminado</option>
                </select>
              )}
              <button
                className="btn btn-light"
                onClick={() => setShowCreditos(!showCreditos)}
                style={{ borderRadius: '8px', width: '40px', height: '40px', padding: '0' }}
              >
                <i className={`bi bi-chevron-${showCreditos ? "up" : "down"}`}></i>
              </button>
            </div>
          </div>

          {showCreditos && (
            <div className="p-3">
              {dataCreditos.length !== 0 ? (
                <Tabla_creditos
                  data={dataCreditos}
                  onClick={onClick}
                  onChange={onChange}
                />
              ) : (
                <div className="text-center py-5">
                  <div className="mb-3" style={{ fontSize: '64px', color: '#E2E8F0' }}>
                    <i className="bi bi-inbox"></i>
                  </div>
                  <p className="text-muted mb-0">
                    {params_credito.persona
                      ? 'No hay créditos disponibles para este cliente'
                      : 'Selecciona un cliente para visualizar sus créditos'}
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
        </div>

        {/* Sección Gastos Judiciales */}
        <div className="mb-4">
        <div className="bg-white rounded-4 shadow-sm overflow-hidden">
          <div className="p-4 d-flex justify-content-between align-items-center" style={{
            background: 'linear-gradient(90deg, #fef3c7 0%, #fde68a 100%)',
            borderBottom: showGastosJudiciales ? '2px solid #fbbf24' : 'none'
          }}>
            <div className="d-flex align-items-center gap-3">
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '12px',
                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '20px'
              }}>
                <i className="bi bi-briefcase"></i>
              </div>
              <div>
                <h3 className="mb-0 fw-bold" style={{ color: '#1E293B' }}>Gastos Judiciales</h3>
                <small className="text-muted">Gestión de gastos y procesos judiciales</small>
              </div>
            </div>

            <button
              className="btn btn-light"
              onClick={() => setShowGastosJudiciales(!showGastosJudiciales)}
              style={{ borderRadius: '8px', width: '40px', height: '40px', padding: '0' }}
            >
              <i className={`bi bi-chevron-${showGastosJudiciales ? "up" : "down"}`}></i>
            </button>
          </div>

          {showGastosJudiciales && (
            <div className="p-3">
              {judiciales ? (
                <Tabla_judiciales
                  data={judiciales}
                  onClick={onClick}
                  onChange={onChange}
                />
              ) : (
                <div className="text-center py-5">
                  <div className="mb-3" style={{ fontSize: '64px', color: '#fde68a' }}>
                    <i className="bi bi-inbox"></i>
                  </div>
                  <p className="text-muted mb-0">
                    {params_credito.persona
                      ? 'No hay gastos judiciales para este cliente'
                      : 'Selecciona un cliente para visualizar sus gastos judiciales'}
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
        </div>

        {/* Panel de Pagos */}
        <div className="mb-4">
        {panelJuicio && juicio ? (
          <PanelJudicial
            juicio={juicio}
            setJuicio={setJuicio}
            setCredito={setCredito}
            setCuota={setCuota}
            setSteps={setSteps}
            steps={steps}
            setPago={setPagoJudicial}
            setComprobante={setComprobanteGasto}
          />
        ) : credito && cuota ? (
          <Panel
            credito={credito}
            cuota={cuota}
            setCredito={setCredito}
            setCuota={setCuota}
            persona={params_credito.persona}
            setSteps={setSteps}
            steps={steps}
            pago={pago}
            setPago={setPago}
            form={form}
            setForm={setForm}
          />
        ) : (
          <div className="bg-white rounded-4 shadow-sm p-5 text-center">
            <div className="mb-4" style={{ fontSize: '80px', color: '#E2E8F0' }}>
              <i className="bi bi-cash-coin"></i>
            </div>
            <h4 className="text-muted mb-2">Registrar Pago</h4>
            <p className="text-muted mb-0">
              Selecciona un crédito o gasto judicial para registrar un pago
            </p>
          </div>
        )}
        </div>

        <Modal
          title="Resumen de pagos"
          id="resumen-credito"
        width={"1500px"}
        onClose={{
          name: "close",
          function: onClick,
        }}
        children={
          resumen && credito ? (
            <Resumen
              data={credito}
              setPago={setPago}
              pago={pago}
              setComprobante={setComprobante}
              usuario={usuario}
              onClick={onClick}
              onChange={onChange}
              setSteps={setSteps}
              steps={steps}
              onClose={onClick}
              persona={params_credito.persona}
            />
          ) : (
            ""
          )
        }
      />

      {/*comprobante ? (
        <Comprobante
          data={pago}
          persona={params_credito.persona}
          onClick={onClick}
        />
      ) : (
        ""
      )*/}

      {comprobanteGasto ? (
        <ComprobanteGastoController
          data={PagoJudicial}
          persona={params_credito.persona}
          onClick={onClick}
        />
      ) : (
        ""
      )}



      <Modal
        title="Resumen de pagos"
        id="resumen-gastos"
        width={"1500px"}
        steps={steps}
        setSteps={setSteps}
        onClose={{
          name: "close",
          function: onClick,
        }}
        children={
          resumenJudicial ? (
            <ResumenJudicial
              data={params_credito.persona}
              juicio={juicio}
              setModal={setResumenJudicial}
              setSteps={setSteps}
              steps={steps}
              onClose={onClick}
              //comprobante={comprobante}
              //setComprobante={setComprobante}
              setPago={setPago}
              pago={pago}
            />
          ) : (
            ""
          )
        }
      />

        {gasto ? (
          <Juicio
            data={params_credito.persona}
            setModal={setGasto}
            setSteps={setSteps}
            usuario={usuario}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default GestionPagos;
